import AppHomeDomainContainer from '~/components/AppHomeDomainContainer';
import AppHomeHeader from '~/components/AppHomeHeader';
import { useEffect, useState } from 'react';
import useGeolocation from '~/hooks/useGeolocation';
import { getCityFromCoords } from '~/services/city';
import { getHomeDrivers } from '~/services/drivers/getHomeDrivers';
import AppHomeEmptyValue from '~/components/AppHomeEmptyValue';
import { AppHomeContainer } from './styles';

export const AppHomeComponent = () => {
  const [selectedCity, setSelectedCity] = useState();
  const [selectedState, setSelectedState] = useState();
  const [selectedPassengersQTD, setSelectedPassengersQTD] = useState(1);
  const [embarkationData, setEmbarkationData] = useState();
  const [disembarkationData, setDisembarkationData] = useState();
  const [isFirstFetch, setIsFirstFetch] = useState(true);
  const [domains, setDomains] = useState([]);
  const [selectedUser, setSelectedUser] = useState('PASSENGER');

  const categories = [
    { name: 'Compartilhada', value: 'shared' },
    { name: 'Particular', value: 'private' },
    { name: 'Delivery', value: 'delivery' },
    { name: 'Mototáxi', value: 'motorbike_taxi' },
    { name: 'Premium', value: 'premium' },
    { name: 'Táxi', value: 'taxi' },
  ];

  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  const onSearch = async (
    embarkationDataTemp,
    disembarkationDataTemp,
    category,
    city,
    seats
  ) => {
    const isOnFirstLoad = !disembarkationDataTemp;
    setIsFirstFetch(isOnFirstLoad);

    const fromLocation = `${embarkationDataTemp.longitude},${embarkationDataTemp.latitude}`;
    let toLocation;

    if (!isOnFirstLoad) {
      toLocation = `${disembarkationDataTemp.longitude},${disembarkationDataTemp.latitude}`;
    }

    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${fromLocation};${toLocation}?access_token=${process.env.REACT_APP_MAP_BOX_API_KEY}`;

    try {
      let response;
      let data;
      let distanceInMeters;

      if (!isOnFirstLoad) {
        response = await fetch(url);
        data = await response.json();

        if (!data.routes || data.routes.length === 0) {
          throw new Error('Nenhuma rota encontrada.');
        }

        distanceInMeters = data.routes[0].distance;
      }

      const kmsDistance = isOnFirstLoad
        ? 0
        : (distanceInMeters / 1000).toFixed(2);

      const result = await getHomeDrivers({
        kms: kmsDistance,
        seats: seats || selectedPassengersQTD,
        latitude: embarkationDataTemp.latitude,
        longitude: embarkationDataTemp.longitude,
        category: category || selectedCategory.name,
        city: city || selectedCity,
      });

      setDomains(result.data.content);
    } catch (err) {
      console.error('Erro ao buscar rota ou motoristas:', err);
    }
  };
  const updatePassengersQTD = (
    increase,
    embarkationInfo,
    disembarkationLocal
  ) => {
    if (increase && selectedPassengersQTD < 4) {
      setSelectedPassengersQTD(selectedPassengersQTD + 1);
      onSearch(
        embarkationInfo.data,
        disembarkationLocal,
        null,
        embarkationInfo.city,
        selectedPassengersQTD + 1
      );
    } else if (!increase && selectedPassengersQTD !== 1) {
      setSelectedPassengersQTD(selectedPassengersQTD - 1);
      onSearch(
        embarkationInfo.data,
        disembarkationLocal,
        null,
        embarkationInfo.city,
        selectedPassengersQTD - 1
      );
    }
  };

  const location = useGeolocation();

  useEffect(() => {
    const fetchCity = async () => {
      const { city, state } = await getCityFromCoords(
        location.latitude,
        location.longitude
      );
      setSelectedCity(city);
      setSelectedState(state);
    };

    if (location.latitude && location.longitude) {
      fetchCity();
    }
  }, [location]);

  return (
    <AppHomeContainer>
      <AppHomeHeader
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        selectedPassengersQTD={selectedPassengersQTD}
        setSelectedPassengersQTD={setSelectedPassengersQTD}
        categories={categories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        updatePassengersQTD={updatePassengersQTD}
        setSelectedState={setSelectedState}
        selectedState={selectedState}
        embarkationData={embarkationData}
        setEmbarkationData={setEmbarkationData}
        disembarkationData={disembarkationData}
        setDisembarkationData={setDisembarkationData}
        onSearch={onSearch}
        setSelectedUser={setSelectedUser}
        selectedUser={selectedUser}
      />

      {domains.length === 0 ? (
        <AppHomeEmptyValue />
      ) : (
        <AppHomeDomainContainer
          domains={domains}
          isFirstFetch={isFirstFetch}
          selectedUser={selectedUser}
        />
      )}
    </AppHomeContainer>
  );
};
